module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-palette"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('div', {
    staticClass: "form-control dropdown-toggle",
    attrs: {
      "href": "#",
      "role": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.value),
      expression: "!value"
    }]
  }, [_vm._v("Selecionar")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "color-palette-preview",
    style: ({
      'background-color': _vm.value
    })
  })]), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('table', {
    staticClass: "color-palette-table"
  }, _vm._l((_vm.colors), function(palette) {
    return _c('tr', _vm._l((palette), function(color) {
      return _c('td', {
        on: {
          "click": function($event) {
            _vm.setColor(color)
          }
        }
      }, [_c('div', {
        staticClass: "color-select",
        style: ({
          'background-color': color
        })
      })])
    }))
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e91a0a56","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/ColorPalette.vue
// module id = 490
// module chunks = 1